import { render, staticRenderFns } from "./DITable.vue?vue&type=template&id=4a839f63&"
import script from "./DITable.vue?vue&type=script&lang=js&"
export * from "./DITable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports